import React, { useEffect, useState } from 'react';
import { Flame } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = ['Juan from Miami', 'Maria from Houston', 'Carlos from NYC', 'Sofia from Orlando', 'David from Los Angeles', 'Elena from Chicago'];
export function SocialProofToast() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before showing first toast
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    // Cycle logic: show for 5s, hide for 3s
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % buyers.length);
        setIsVisible(true);
      }, 3000); // 3s hidden
    }, 8000); // 8s total cycle
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, []);
  return <div className="fixed bottom-6 left-6 z-40 pointer-events-none" data-id="element-215">
      <AnimatePresence data-id="element-216">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-[#111] border border-gray-800 shadow-2xl rounded-lg p-4 flex items-center gap-4 max-w-sm" data-id="element-217">
            <div className="bg-orange-500/10 p-2 rounded-full" data-id="element-218">
              <Flame className="w-5 h-5 text-orange-500 animate-pulse" data-id="element-219" />
            </div>
            <div data-id="element-220">
              <p className="text-sm font-medium text-white" data-id="element-221">
                {buyers[currentIndex]}
              </p>
              <p className="text-xs text-gray-400 mt-0.5" data-id="element-222">
                purchased a copy 5 min ago
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}